import React from 'react';

export default function SpaceSection() {
  return (
    <section id="espaco" className="py-24 lg:py-32" style={{ background: '#FFC2D4' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          {/* Text */}
          <div>
            <span className="gold-line mb-6 block" />
            <p className="text-xs tracking-[0.25em] uppercase font-medium text-burnt-rose mb-4">
              O Nosso Espaço
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl font-light leading-[1.1] text-dark-brown mb-8">
              Um espaço pensado<br />
              <em className="italic text-burnt-rose">para cuidar de si.</em>
            </h2>
            <div className="space-y-4 text-foreground/70 leading-relaxed">
              <p className="text-base lg:text-lg">
                O nosso estúdio foi concebido para proporcionar uma experiência de beleza que vai além do tratamento em si. Cada detalhe foi pensado para criar um ambiente de tranquilidade, elegância e conforto.
              </p>
              <p className="text-base">
                Localizado no coração de Maputo, na Rua da Malhangalene, o espaço combina privacidade com sofisticação — para que cada visita seja um momento verdadeiramente seu.
              </p>
            </div>

            {/* Location detail */}
            <div className="mt-8 p-5 bg-white rounded-xl border border-border">
              <p className="text-xs tracking-[0.15em] uppercase text-burnt-rose font-medium mb-2">Localização</p>
              <p className="text-sm text-foreground/80 leading-relaxed">
                Rua da Malhangalene, esquina com a Rua da Resistência<br />
                Cidade de Maputo, Moçambique
              </p>
            </div>
          </div>

          {/* Image composition */}
          <div className="relative">
            {/* Main large image */}
            <div className="rounded-2xl overflow-hidden aspect-[3/4]">
              <img
                src="/assets/images/IMG-20260914-WA0164-1789413203348.jpg"
                alt="Interior elegante do estúdio Mãos Mágicas em Maputo"
                className="w-full h-full object-cover" />
              
            </div>
            {/* Decoration */}
            <div className="absolute -top-4 -right-4 w-full h-full rounded-2xl -z-10" style={{ background: '#FFD6E0' }} />
          </div>
        </div>
      </div>
    </section>);

}